import React from 'react';

import { PopoverPlacement } from '@rover/components/src/callouts/Popover/popover.constants';
import { Box, Image } from '@rover/kibble/core';
import {
  getAvatarBorderRadius,
  getDesktopAvatarSize,
} from '@rover/react-lib/src/pages/search/SearchPage/utilities/searchCardTreatment';
import Badge from '@rover/react-lib/src/pages/search/shared/components/SitterBadge';
import { SearchCardTreatment } from '@rover/types/src/SearchCardTreatment';
import type { SitterBadge } from '@rover/types/src/SitterBadge';

import { AVATAR_BADGE_SIZES, SEARCH_RESULT_CARD_Z_INDEX } from '../SearchResultCard.constants';

type Props = {
  imageUrl: string;
  lazy: boolean;
  badge?: SitterBadge;
  displayExpanded: boolean;
  description: string;
  cardTreatment: SearchCardTreatment;
};

export default function DesktopAvatar({
  imageUrl,
  lazy,
  badge,
  displayExpanded,
  description,
  cardTreatment,
}: Props): React.ReactElement {
  const avatarSize = getDesktopAvatarSize(cardTreatment, displayExpanded);
  const borderRadius = getAvatarBorderRadius(cardTreatment);

  const avatarBadgeSize = displayExpanded
    ? AVATAR_BADGE_SIZES.EXPANDED
    : AVATAR_BADGE_SIZES.REDUCED;

  return (
    <Box position="relative" height={avatarSize} width={avatarSize}>
      <Image
        src={imageUrl}
        description={description}
        height="100%"
        width="100%"
        webProps={{ eager: !lazy }}
        borderRadius={borderRadius}
      />
      {badge && (
        <Box
          position="absolute"
          bottom="0"
          right="0"
          width={avatarBadgeSize}
          height={avatarBadgeSize}
          zIndex={`${SEARCH_RESULT_CARD_Z_INDEX.INTERACTIVE}`}
        >
          <Badge
            title={badge.title}
            content={badge.content}
            imageUrl={badge.imageUrl}
            key={badge.imageUrl}
            slug={badge.slug}
            width={avatarBadgeSize}
            popoverPlacement={PopoverPlacement.RIGHT}
          />
        </Box>
      )}
    </Box>
  );
}
